import { ICustomQuestionGetResponse } from "@performyard/models";

import { getEngagementSurveyURLPrefix } from "../../../../../../../utils/URLs/EngagementSurvey";

export const getQuestionURL = (customQuestion: Pick<ICustomQuestionGetResponse, "question" | "scale">) => {
	const { question = "", scale } = customQuestion;
	let prefix = getEngagementSurveyURLPrefix();
	const urlEncodedQuestion = encodeURIComponent(question);
	prefix = prefix.includes("localhost") ? prefix : `${prefix}`;

	return `${prefix}/survey-forms/preview/${scale}/${urlEncodedQuestion}/`;
};
